import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [config, setConfig] = useState(null);
  const check = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    check();
  }, [check]);
  useEffect(() => {
    if (user) {
      api.get("/config/public").then((r) => setConfig(r.data));
    }
  }, [user]);
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, logout, config, check }}>{children}</AuthCtx.Provider>;
}

const LangCtx = createContext(null);
export const useLang = () => useContext(LangCtx);
const DICT = {
  hi: {
    "Open a Savings Account": "बचत खाता खोलें", "Open a Current Account": "चालू खाता खोलें", "I Already Have a Current Account": "मेरे पास पहले से चालू खाता है",
    "Resume an Existing Application": "मौजूदा आवेदन जारी रखें", "Track Application Status": "आवेदन की स्थिति देखें", Next: "आगे", Back: "पीछे",
    "Save & exit": "सहेजें और बाहर निकलें", Required: "आवश्यक", Optional: "वैकल्पिक", Submit: "जमा करें", Dashboard: "डैशबोर्ड", Applications: "आवेदन",
    "Saved": "सहेजा गया", "Unsaved changes": "असहेजे बदलाव", "Required (conditional)": "आवश्यक (शर्तसहित)",
    "This field is required": "यह फ़ील्ड आवश्यक है", "Please confirm to continue": "जारी रखने के लिए पुष्टि करें", "Saved on server": "सर्वर पर सहेजा गया", "Saving…": "सहेजा जा रहा है…", "Sign out": "साइन आउट", Home: "होम", Documents: "दस्तावेज़", Review: "समीक्षा",
  },
};
export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const t = (s) => (lang === "hi" && DICT.hi[s]) || s;
  const switchLang = (l) => {
    localStorage.setItem("lang", l);
    setLang(l);
  };
  return <LangCtx.Provider value={{ lang, t, setLang: switchLang }}>{children}</LangCtx.Provider>;
}
